module.exports = __webpack_public_path__ + "media/images/tutorial_body_sp1-02-495e7ce2eadc3aefa4028a7b99aaf8ef.png";